import update from 'immutability-helper';
import { createCase, createSwitch } from 'helpers/action-helpers';
import { initialState, GridLayoutType } from './state';
import { SelectRowAction, SetColumnsAction, SetRowsAction } from './actions';

export const userGridReducer = createSwitch(initialState, [
  createCase(new SelectRowAction(''), (state, action) => {
    return update(state, {
      selectedRow: { $set: action.rowId }
    });
  }),
  createCase(new SetRowsAction([]), (state, action) => {
    return update(state, {
      rows: { $set: action.rows }
    });
  }),
  createCase(new SetColumnsAction(GridLayoutType.usersComputer, []), (state, action) => {
    return update(state, {
      layouts: {
        [action.gridLayoutType]: {
          columns: { $set: action.columns }
        }
      }
    });
  })
]);


// WEBPACK FOOTER //
// ./src/components/user-grid/reducer.ts